<template>
  <nav class="navbar">
    <button
      @click="$emit('change', 'map')"
      :class="{
        mapButton: true,
        active: mode === 'map',
      }"
    >
      Kart
    </button>
    <button
      @click="$emit('change', 'list')"
      :class="{
        listButton: true,
        active: mode !== 'map',
      }"
    >
      Liste
    </button>
  </nav>
</template>

<script>
export default {
  name: 'BSNavigation',
  model: {
    prop: 'mode',
    event: 'change',
  },
  props: {
    mode: String,
  },
}
</script>

<style lang="scss">
.navbar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3rem;
  display: flex;
  justify-content: center;
  > * {
    flex: 1 1 auto;
    max-width: 15rem;
    border: 1px solid black;
    background: white;
    font-family: inherit;
    margin: 0.5rem 1rem;
    border-radius: 0.5rem;
    &:first-child {
      margin-right: 0;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    &:last-child {
      margin-left: 0;
      border-left: 0;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    &.active {
      font-weight: bold;
      background: #eee;
    }
    &:focus {
      outline: none;
    }
  }
}
</style>
